/** biome-ignore-all lint/suspicious/noArrayIndexKey: <explanation> */
import type { JSX } from "react";

interface OriginalTextProps {
	text: string;
	indexes: { startIndex: number; endIndex: number; score?: number }[];
}

export function OriginalText({ text, indexes }: OriginalTextProps) {
	// Function to render text with highlights
	const renderHighlightedText = () => {
		if (!indexes || indexes.length === 0) {
			return <p>{text}</p>;
		}

		// Sort indexes by start position to ensure proper rendering
		const sortedIndexes = [...indexes].sort(
			(a, b) => a.startIndex - b.startIndex,
		);

		const parts: JSX.Element[] = [];
		let lastIndex = 0;

		sortedIndexes.forEach((range, index) => {
			// Add text before the highlight
			if (range.startIndex > lastIndex) {
				parts.push(
					<span key={`text-${index}`}>
						{text.slice(lastIndex, range.startIndex)}
					</span>,
				);
			}

			const backgroundColor = getBackgroundColorForScore(range.score);

			// Add highlighted text
			parts.push(
				<span
					key={`highlight-${index}`}
					className={`${backgroundColor} px-1 rounded`}
				>
					{text.slice(range.startIndex, range.endIndex)}
				</span>,
			);

			lastIndex = range.endIndex;
		});

		// Add remaining text after the last highlight
		if (lastIndex < text.length) {
			parts.push(<span key="text-end">{text.slice(lastIndex)}</span>);
		}

		return <p className="text-sm">{parts}</p>;
	};

	return <div className="px-3">{renderHighlightedText()}</div>;
}

function getBackgroundColorForScore(score?: number) {
	if (score == null) {
		// winston plagiarism indexes don't have a score
		return "bg-red-100";
	}
	if (score <= 0.1) {
		return "";
	} else if (score <= 0.3) {
		return "bg-yellow-100";
	} else if (score <= 0.7) {
		return "bg-red-100";
	} else {
		return "bg-red-200";
	}
}
